<template>
  <div class="uk-section uk-animation-fade-bottom-medium">
    <div class="uk-container">
      <div class="ee-blog-title title uk-light uk-margin-large-bottom">
        <h1>Richelle's Blog</h1>
      </div>
      <div class="uk-grid-small uk-text-left" uk-grid>
        <div class="uk-width-3-4@m">
          <div class="ee-blog-content uk-light" v-html="article"></div>
        </div>
        <div class="uk-width-1-4@m">
          <div class="uk-card uk-card-small uk-card-secondary">
            <div class="uk-card-header">
              <h3 class="uk-card-title">{{ menu.label }}</h3>
            </div>
            <div class="uk-card-body">
              <ee-tree-menu :key="menu.link" :label="menu.label" :nodes="menu.children" :link="menu.link"></ee-tree-menu>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.ee-blog-content >>> h1.uk-article-title {
  font-family: 'Patua One', serif !important;
}

.ee-blog-content >>> p {
  /* font-family: 'Advent Pro', sans-serif; */
}

.ee-blog-title >>> h1 {
  /* font-size: 5em; */
  font-family: 'Dancing Script', cursive;
  /* text-transform: uppercase; */
}

.uk-card-body {
  padding: 40px;
}
</style>

<script>
import TreeMenu from '@/components/shared/TreeMenu'
import { findItemInChildArray } from '@/util'

export default {
  name: 'blog',
  components: {
    'ee-tree-menu': TreeMenu
  },
  metaInfo () {
    const menuItem = findItemInChildArray(this.menu, x => ('/' + x.link) === this.$route.path, 'children')
    const label = menuItem ? menuItem.label : ''
    const imageUrl = menuItem ? `http://assets.experience-excellence.nl.s3.amazonaws.com/images/${menuItem.part}.jpg` : ''
    const url = `http://www.experience-excellence.nl${this.$route.path}`

    return {
      meta: [
        {
          'property': 'og:title',
          'content': label
        },
        {
          'property': 'og:type',
          'content': 'article',
          'template': null
        },
        {
          'property': 'og:url',
          'content': url
        },
        {
          'property': 'og:image',
          'content': imageUrl
        }]
    }
  },
  data: () => ({
    menu: {},
    article: '',
    currentBlogItem: '',
    currentMenuItem: { label: 'blog' }
  }),
  methods: {
    updateBlog (url) {
      let newBlogItem = 'http://cms.experience-excellence.nl.s3.amazonaws.com' + url

      if (url === '/blog') {
        newBlogItem += '/welkom'
      }

      if (newBlogItem === this.currentBlogItem) {
        return
      }

      this.currentBlogItem = newBlogItem

      fetch(newBlogItem).then((response) => {
        if (response && response.ok) {
          return response.text().then((text) => {
            this.article = text
          })
        }
      })
    }
  },
  watch: {
    $route (to, from) {
      this.updateBlog(to.fullPath)
    }
  },
  created: function () {
    fetch(
      'http://cms.experience-excellence.nl.s3.amazonaws.com/.dodgercms/data.json'
    ).then((response) => {
      return response.json().then((json) => {
        if (!json) return
        this.menu = json.find(x => x.part === 'blog')
      })
    })
  },
  beforeUpdate () {
    this.updateBlog(this.$route.path)
  },
  updated () {
    window.prerenderReady = true
  }
}
</script>




// WEBPACK FOOTER //
// src/components/pages/Blog.vue